import api from '@/api/app'
import { Message } from 'element-ui'
const library = {
  library: {
    viewInfo: {
      obj: {
        data1: [
          {
            title: '示范图书馆申报',
            url: require('@/assets/icon/library.png'),
            path: '/library/index',
            option: '点击进入'
          }
        ],
        tabs: [
          {
            id: 111,
            key: 0,
            name: '创建通知',
            type: 'text'
          },
          {
            id: 222,
            key: 1,
            name: '在线申报',
            type: 'text'
          },
          {
            id: 333,
            key: 2,
            name: '历年评比',
            type: 'text'
          }
        ]
      },
      data: {}
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: [],
      conditions: () => {
        return new Promise((resolve) => {
          api.library.retrieve.about1().then((res) => {
            resolve(res.data[0].children)
          })
        })
      },
      areas: () => {
        return new Promise((resolve) => {
          api.school.retrieve.conditions().then((res) => {
            resolve(res.data[1].children)
          })
        })
      }
    }
  },
  file: {
    viewInfo: {
      obj: {
        tabs: [
          {
            id: 1,
            key: 0,
            name: '创建通知',
            type: 'text'
          },
          {
            id: 2,
            key: 1,
            name: '照明标准',
            type: 'text'
          },
          {
            id: 3,
            key: 2,
            name: '藏书比例',
            type: 'text'
          },
          {
            id: 4,
            key: 3,
            name: '示范标准',
            type: 'text'
          }
        ],
        table2: [
          {
            type: 'text',
            model: 'name',
            label: '参 数',
            width: '',
            align: 'center'
          },
          {
            type: 'text',
            model: 'num',
            label: 'GB 7793-2010',
            width: '',
            align: 'center'
          }
        ],
        tableHead: {
          'background-color': '#f5f9fd',
          color: '#2778fb'
        }
      },
      data: {
        data1: {
          title: '河南省中小学示范性图书馆创建标准',
          content: [
            {
              label: '创建图书馆必须达到以下六点要求：',
              indent: '2em',
              type: 'title'
            },
            {
              label: '1.图书馆实行信息化管理。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '3.生均配备图书标准：小学≥30 册；初中≥40 册；高中≥50 册；完中≥45 册。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '4.近 3 年，生均纸质图书年递增量不少于 1.5 册。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '5.近 3 年，每学年生均借阅图书册数，小学不少于 8 册，中学不少于 10 册。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '6.图书馆馆配图书适宜性评价自评工作已完成。',
              indent: '2em',
              type: 'content'
            }
          ]
        },
        data2: {
          title: 'GB 7793-2010 中小学校教室采光和照明卫生标准',
          content: [
            {
              name: '普通教室课桌面照度(lx)',
              num: '≥300'
            },
            {
              name: '黑板面照度(lx)',
              num: '≥500'
            },
            {
              name: '教室照度均匀度(U0)',
              num: '≥0.7'
            },
            {
              name: '黑板照度均匀度(U0)',
              num: '≥0.8'
            },
            {
              name: '显色指数(Ra)',
              num: '≥80'
            },
            {
              name: '色温(K)',
              num: '3300-5500'
            },
            {
              name: '视网膜光生物安全性',
              num: '未提及'
            },
            {
              name: '频闪(波动深度)',
              num: '未提及'
            },
            {
              name: '统一眩光值(UGR)',
              num: '≤19'
            },
            {
              name: '(照明)功率密度(W/㎡)',
              num: '≤11'
            },
            {
              name: '维护系数',
              num: '0.8'
            }
          ]
        },
        data3: {
          title: '中小学图书馆（室）藏书分类比例表',
          // 部类>五大部类 category 22个基本部类basic||分类比例>小学primary 中学middle
          content: [
            {
              category: '第一大类',
              basic: ['A 马克思主义、列宁主义、毛泽东思想、邓小平理论、习近平新时代中国特色社会主义思想'],
              primary: '1.5%',
              middle: '2%'
            },
            {
              category: '第二大类',
              basic: ['B 哲学、宗教'],
              primary: '1.5%',
              middle: '2%'
            },
            {
              category: '第三大类',
              basic: [
                'C 社会科学总论',
                'D 政治法律',
                'E 军事',
                'F 经济',
                'G 文化、科学、教育、体育',
                'H 语言、文字',
                'I 文学',
                'J 艺术',
                'K 历史、地理'
              ],
              primary: '64%',
              middle: '54%'
            },
            {
              category: '第四大类',
              basic: [
                'N 自然科学总论',
                'O 数理科学和化学',
                'P 天文学、地球科学',
                'Q 生物科学',
                'R 医药、卫生',
                'S 农业科学',
                'T 工业技术',
                'U 交通运输',
                'V 航空、航天',
                'X 环境科学、安全科学'
              ],
              primary: '28%',
              middle: '38%'
            },
            {
              category: '第五大类',
              basic: ['Z 综合性图书'],
              primary: '5%',
              middle: '4%'
            }
          ]
        },
        data4: {
          title: '河南省教育厅关于开展河南省中小学示范性图书馆创建工作的通知',
          content: [
            {
              label: '各省辖市、省直管县（市）教育局：',
              indent: '0em',
              type: 'content'
            },
            {
              label: '为落实立德树人根本任务，进一步推动全省中小学图书馆建设，充分发挥中小学图书馆在深化基础教育改革、全面推进素质教育过程中的应有作用，根据教育部《关于新形势下进一步做好普通中小学装备工作的意见》（教基一〔2016〕3号）和省教育厅《关于加强和改进中小学图书馆装备工作的通知》（教技装〔2018〕609号）文件精神，决定在全省开展中小学示范性图书馆创建工作。现将有关事宜通知如下：',
              indent: '2em',
              type: 'content'
            },
            {
              label: '一、指导思想',
              indent: '2em',
              type: 'title'
            },
            {
              label: '以习近平新时代中国特色社会主义思想为指导，以推动教育现代化为目标，以建设中小学示范性图书馆为引领，坚持科学性、导向性、适宜性，充分发挥示范辐射作用，进一步促进全省中小学图书馆整体水平的提升。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '二、创建目标',
              indent: '2em',
              type: 'title'
            },
            {
              label: '全省中小学示范性图书馆创建工作分三年完成，从2020年开始，每年创建200所。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '三、创建对象',
              indent: '2em',
              type: 'title'
            },
            {
              label: '全省普通中小学校图书馆（室）。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '四、创建标准',
              indent: '2em',
              type: 'title'
            },
            {
              label: '按照《河南省中小学示范性图书馆创建标准》（以下简称《创建标准》。《创建标准》共5大项，总分110分。创建图书馆（室）得分原则上不低于90分。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '五、创建程序',
              indent: '2em',
              type: 'title'
            },
            {
              label: '各地要选择装备基础较好、管理规范、应用创新、资金有保障的中小学校图书馆作为遴选目标，并认真组织学校申报。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '（一）学校申报',
              indent: '2em',
              type: 'content'
            },
            {
              label: '按照《创建标准》开展创建工作，重点针对存在的问题和薄弱环节，加强领导，加大投入，采取措施，抓好创建。拟申报学校填写申报表，首先自评，得分90分以上的可以申报，材料报至所属省辖市、省直管县（市）教育局。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '（二）市县初评',
              indent: '2em',
              type: 'content'
            },
            {
              label: '各省辖市、省直管县（市）教育局组织初评。加强过程指导，重在以评促建，弥补各项短板，逐项达标提升。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '（三）省厅评估',
              indent: '2em',
              type: 'content'
            },
            {
              label: '初评核查合格的学校，由各省辖市、省直管县（市）教育局统一汇总纸质版和电子版相关材料报省教育技术装备管理中心。材料包括：《河南省中小学示范性图书馆申报表》，《河南省中小学示范性图书馆申报汇总表》，各省辖市、省直管县（市）中小学示范性图书馆创建工作方案、工作总结，创建学校图书馆装备情况表、自评报告和反映学校图书馆基本情况的图片资料（不少于20幅，图片资料上应注明学校名称）及视频资料（5分钟左右，充分反映图书馆概貌、借阅、活动等场景以及本馆特色）。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '省厅评估工作由省教育技术装备管理中心组织实施。具体办法另行通知。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '（四）动态管理',
              indent: '2em',
              type: 'content'
            },
            {
              label: '通过省厅评估验收的，确定为河南省中小学示范性图书馆，由省教育厅统一公布，颁发牌匾。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '河南省中小学示范性图书馆实行总量控制、动态管理，原则上每三年进行复查。发现问题的，限期整改；问题严重的，取消河南省中小学示范性图书馆称号。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '六、有关要求',
              indent: '2em',
              type: 'title'
            },
            {
              label: '各地要统一思想，提高认识，加强领导，加大投入，以创建工作为契机，以评促建，以评促改，评建结合，充分发挥示范引领作用，不断提升全省中小学图书馆的建设、配备、管理、应用、培训和评估水平。省教育技术装备管理中心要加强指导，精心组织，及时发现典型，及时推广各地各学校好经验好做法，推动中小学图书馆向标准化、规范化、现代化迈进。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '各地如有意见或建议请与省教育技术装备管理中心联系。',
              indent: '2em',
              type: 'content'
            },
            {
              label: '联 系 人：李  媛     联系电话：17537120925',
              indent: '2em',
              type: 'content'
            },
            {
              label: '邮    箱：hnjyzbtsg@163.com',
              indent: '2em',
              type: 'content'
            }
          ]
        }
      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: []
    }
  },
  declare: {
    viewInfo: {
      obj: {
        tabs: [
          {
            id: 1,
            key: 0,
            name: '在线申报',
            type: 'text'
          },
          {
            id: 3,
            key: 1,
            name: '图片资料',
            type: 'text'
          }
        ],
        tabs1: [
          {
            id: 2,
            key: 0,
            name: '我的报告',
            type: 'text'
          },
          {
            id: 3,
            key: 1,
            name: '图片资料',
            type: 'text'
          }
        ],
        tabs2: [
          {
            id: 1,
            key: 0,
            name: '在线申报',
            type: 'text'
          },
          {
            id: 2,
            key: 1,
            name: '体制队伍',
            type: 'text'
          },
          {
            id: 3,
            key: 2,
            name: '条件保障',
            type: 'text'
          },
          {
            id: 4,
            key: 3,
            name: '管理工作',
            type: 'text'
          },
          {
            id: 5,
            key: 4,
            name: '读者工作',
            type: 'text'
          },
          {
            id: 6,
            key: 5,
            name: '特色创新',
            type: 'text'
          }
        ],
        tabs3: [
          {
            id: 1,
            key: 0,
            name: '我的图片',
            type: 'text'
          },
          {
            id: 2,
            key: 1,
            name: '我的视频',
            type: 'text'
          }
        ],
        btns1: [
          {
            label: '上传审核',
            status: 0,
            icon: require(`@/assets/icon/icon-unload5.png`),
            activeIcon: require(`@/assets/icon/icon-unload4.png`),
            model: 'add'
          },
          {
            label: '下载审核',
            status: 0,
            icon: require(`@/assets/icon/icon-down5.png`),
            activeIcon: require(`@/assets/icon/icon-down4.png`),
            model: 'down'
          },
          {
            label: '提交审核',
            status: 0,
            icon: require(`@/assets/icon/icon-submit5.png`),
            activeIcon: require(`@/assets/icon/icon-submit4.png`),
            model: 'submit'
          },
          {
            label: '返回编辑',
            status: 0,
            icon: require(`@/assets/icon/icon-edit5.png`),
            activeIcon: require(`@/assets/icon/icon-edit4.png`),
            model: 'edit'
          }
        ],
        btns2: [
          {
            label: '查看审核',
            status: 0,
            icon: require(`@/assets/icon/icon-examine5.png`),
            activeIcon: require(`@/assets/icon/icon-examine4.png`),
            model: 'examine'
          },
          {
            label: '下载审核',
            status: 0,
            icon: require(`@/assets/icon/icon-down5.png`),
            activeIcon: require(`@/assets/icon/icon-down4.png`),
            model: 'down'
          },
          {
            label: '撤销审核',
            status: 0,
            icon: require(`@/assets/icon/icon-repeal5.png`),
            activeIcon: require(`@/assets/icon/icon-repeal4.png`),
            model: 'repeal'
          }
        ]
      },
      data: {
        borrowTypes: [
          {
            id: 1,
            label: '全开架'
          },
          {
            id: 2,
            label: '半开架'
          },
          {
            id: 3,
            label: '闭架'
          }
        ],
        trainTypes: [
          {
            id: 1,
            label: '省级'
          },
          {
            id: 2,
            label: '市级'
          },
          {
            id: 3,
            label: '县级'
          }
        ],
        schoolTypes: [
          {
            'id': 1,
            'name': '完中'
          },
          {
            'id': 2,
            'name': '高中'
          },
          {
            'id': 3,
            'name': '初中'
          },
          {
            'id': 4,
            'name': '小学'
          }
        ],
        zxsbConfig: {
          bjs: [9999, '请填写班级数'],
          xss: [9999, '请填写学生数'],
          rjmcjbb: [9999, '请填写软件名称以及版本'],
          rjzcsj: [30, '请选择软件注册时间'],
          jrfs: null,
          tszs: [9999999, '请填写馆藏图书整数'],
          sjpbtss: [9999999, '请填写生活配备图书数量'],
          zzrysl: [9999, '请填写专职人员数量'],
          gzsz: [100, '请填写学历'],
          jsjzs: [100, '请填写计算机证书'],
          ywpx: null
        },
        tzdw: [
          {
            label: '创建项目',
            child: [
              [
                {
                  type: 'str',
                  label: '创建内容',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '创建内容说明',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '分值',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '自评',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '得分',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '创建标准',
                  height: '120px'
                }
              ]
            ]
          },
          {
            label: '体制（7 分）',
            child: [
              [
                {
                  type: 'str',
                  label: '1.体制（2分）',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '实行校长领导下的馆长负责制，有一名校级领导直接分管图书馆工作，馆长享受不低于教研组长待遇。',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '2',
                  height: '80px'
                },
                {
                  type: 'input',
                  label: 'tz',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '有学校校级领导直接分管，得1分；馆长享受不低于学校教研组长待遇，得 1 分。',
                  height: '80px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '2.机构（2分）',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '学校根据需要设立阅读指导机构，由一名校级领导担任负责人，指导和协调全校阅读活动开展。',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '2',
                  height: '80px'
                },
                {
                  type: 'input',
                  label: 'jg',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '设立阅读指导机构，得 1 分；校级领导担任负责人，得 1分。',
                  height: '80px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '3.纳入整体规划（3 分）',
                  height: '160px'
                },
                {
                  type: 'str',
                  label: 'A.积极贯彻落实教育部《中小学图书馆（室）规程（修订）》和《河南省教育厅关于加强和改进中小学图书馆装备工作的通知》。B.学校领导把图书馆工作纳入学校整体规划，有计划、有检查、有总结。C.图书馆工作人员在调资晋级或评先评优时与教学人员同等看待。',
                  height: '160px'
                },
                {
                  type: 'str',
                  label: '3',
                  height: '160px'
                },
                {
                  type: 'input',
                  label: 'nrztgh',
                  height: '160px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '160px'
                },
                {
                  type: 'str',
                  label: '每项 1 分。',
                  height: '160px'
                }
              ]
            ]
          },
          {
            label: '队伍 （8 分）',
            child: [
              [
                {
                  type: 'str',
                  label: '4.人员配备 （2 分）',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '初中：24 班以下，配备图书馆管理人员≥2 人 ； 高中、完中：24班以下，配备图书馆管理人员 ≥4 人；中学：24 班以上，每增加 12班，需增 加 1 人。',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '2',
                  height: '100px'
                },
                {
                  type: 'input',
                  label: 'rypb',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '达到，得 2 分；达不到，不得 分。',
                  height: '100px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '5.专业素养 （4 分）',
                  height: '160px'
                },
                {
                  type: 'str',
                  label: 'A.图书馆管理人员应当具备大学本科以上学历。B.图书馆馆长具有中级以上职称，熟悉图书馆业务，具备计算机操作技能，能担负全面管理 责任。C.其余人员要掌握图书馆专业技能和计算机基 础知识。D.馆长应图书馆学专业毕业或经市级以上培训，成绩合格；其他人员近两年内接受过县级以上图书管理知识培训，成绩合格。',
                  height: '160px'
                },
                {
                  type: 'str',
                  label: '4',
                  height: '160px'
                },
                {
                  type: 'input',
                  label: 'zysy',
                  height: '160px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '160px'
                },
                {
                  type: 'str',
                  label: '每项 1 分。',
                  height: '160px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '6.人员管理 （2 分）',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: 'A.做好图书馆人员使用、培训、考核、评聘等 工作。B.五年内管理人员更换不超过 50％。',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '2',
                  height: '100px'
                },
                {
                  type: 'input',
                  label: 'rygl',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '每项 1 分。',
                  height: '100px'
                }
              ]
            ]
          },
          {
            label: '成果 (2 分)',
            child: [
              [
                {
                  type: 'str',
                  label: '7.课题、论 文（2 分）',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: 'A.近 5 年来，图书馆管理人员主动了解学校教学的动态和教师科研状况，积极主动地开展个性化服务，开展研究性学习指导等活动并有相 关研究课题成果。B.近 5 年来，图书馆集体或工作人员个人在省级以上专业刊物发表文章，在市级以上论文评 选中获奖。',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '2',
                  height: '120px'
                },
                {
                  type: 'input',
                  label: 'ktlw',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '市级以上课题得 1 分，县区级 课题得 0.5 分。可累计，但最多得 1 分。 省级以上专业刊物发表文章， 得 1分；市级以上论文评选中 获奖，得 0.5 分。可累计，但 最多得 1分。',
                  height: '120px'
                }
              ]
            ]
          }
        ],
        tzdwConfig: {
          tz: [2, 0.5, '请填写数字且最大为2'],
          jg: [2, 0.5, '请填写数字且最大为2'],
          nrztgh: [3, 0.5, '请填写数字且最大为2'],
          rypb: [2, 0.5, '请填写数字且最大为2'],
          zysy: [4, 0.5, '请填写数字且最大为4'],
          rygl: [2, 0.5, '请填写数字且最大为2'],
          ktlw: [2, 0.5, '请填写数字且最大为2']
        },
        tjbz: [
          {
            label: '创建项目',
            child: [
              [
                {
                  type: 'str',
                  label: '创建内容',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '创建内容说明',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '分值',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '自评',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '得分',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '创建标准',
                  height: '120px'
                }
              ]
            ]
          },
          {
            label: '馆舍设施（19 分）',
            child: [
              [
                {
                  type: 'str',
                  label: '8. 馆舍 面积（9 分）',
                  height: '400px'
                },
                {
                  type: 'arr',
                  label: ['图书馆馆舍生均使用面积：初中≥0.6㎡，高中、完中≥0.7㎡，馆舍使用面积包括藏书室、采编室、学生阅览室、教师阅览室、电子阅览室等。', '学生阅览室：初中座位数≥学生总数的15%，每座面积≥1.8㎡。高中、完中座位数≥学生总数的15%，每座面积≥1.9㎡。', '教师阅览室：座位数≥教师总数的33%，每座面积≥2.3㎡。', '电子、视听阅览室：座位≥55 座，每座使用面积≥2.0 ㎡。', '采编室：采编室面积≥15㎡。'],
                  height: '80px'
                },
                {
                  type: 'arr',
                  label: ['2', '2', '2', '2', '1'],
                  height: '80px'
                },
                {
                  type: 'inputArr',
                  label: ['gsmj_tsggs', 'gsmj_xsyls', 'gsmj_jsyls', 'gsmj_dzstyls', 'gsmj_cbs'],
                  height: '80px'
                },
                {
                  type: 'arr',
                  label: ['', '', '', '', ''],
                  height: '80px'
                },
                {
                  type: 'arr',
                  label: ['达到得 2 分，每少 0.1㎡扣 1分,最多扣 2 分。', '每项 1 分。', '每项 1 分。', '每项 1 分。电子、视听阅览室可与学校电脑教室合用。', '达到得 1 分。'],
                  height: '80px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '9. 设施 要求（1 分）',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '馆舍位置合理，环境安静；照明设施齐全，采光良好；图书馆应达到绿化、美化、整洁卫生。',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '1',
                  height: '80px'
                },
                {
                  type: 'input',
                  label: 'ssyq',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '缺 1 项扣 0.5 分，最多扣 1分。',
                  height: '80px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '10.陈列设施（1 分）',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '书架（柜），报刊架，借阅台，自助借阅设备，过刊架（柜），报架（柜），书车，光盘、音像资料柜等配备齐全，排列合理，方便读者查阅。',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '1',
                  height: '80px'
                },
                {
                  type: 'input',
                  label: 'clss',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '缺一项扣 0.5 分，最多扣 1分。',
                  height: '80px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '11.办公设施（1 分）',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '配有独立办公台、计算机、装订机、复印机、扫描仪、打印机、空调等。',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '1',
                  height: '80px'
                },
                {
                  type: 'input',
                  label: 'bgss',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '缺一项扣 0.5 分，最多扣 1分。',
                  height: '80px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '12.电子阅览室设施（4 分）',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '配备：①服务器 1 台，②交换机 1 台，③计算机≥55 台。',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '4',
                  height: '80px'
                },
                {
                  type: 'input',
                  label: 'dzylsss',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '达到得 4 分，达不到不得分。',
                  height: '80px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '13.防护设施（1 分）',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '应配备图书吸尘设备、防盗设备、消防设备、通风换气设备、防潮设备、防虫药品等。',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '1',
                  height: '80px'
                },
                {
                  type: 'input',
                  label: 'fhss',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '缺一项扣 0.5 分，最多扣 1分。',
                  height: '80px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '14.灯光照明（2 分）',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '严格按照《GB 7793-2010中小学校教室采光和照明卫生标准》设置执行',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '2',
                  height: '80px'
                },
                {
                  type: 'input',
                  label: 'dgzm',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '一项不达标扣 0.5 分，最多扣 2 分。',
                  height: '80px'
                }
              ]
            ]
          },
          {
            label: '藏书建设（14 分）',
            child: [
              [
                {
                  type: 'str',
                  label: '15.藏书刊量（8 分）',
                  height: '600px'
                },
                {
                  type: 'arr',
                  label: ['初中：生均藏书量≥40 册。高中：生均藏书量≥50册。完中：生均藏书量≥45 册。', '近三年，生均图书年递增量≥1.5 册。', '报刊种类：初中≥100 种；高中、完中≥200 种。', '工具书、参考书种类：初中≥200 种；高中、完中≥300 种。', '配有数字图书(配备的数量不低于按要求总馆藏纸质图书的15%)和电子报刊资料。数字文献应有合法数字版权和应用系统、能进行全文检索和内容摘录、兼容性好可扩展，更新及时，能正常投入使用。馆藏文献中还应有一定数量的视听资料。'],
                  height: '120px'
                },
                {
                  type: 'arr',
                  label: ['4', '1', '1', '1', '1'],
                  height: '120px'
                },
                {
                  type: 'inputArr',
                  label: ['cskl_cz', 'cskl_jsn', 'cskl_bkzl', 'cskl_gjsckszl', 'cskl_pyszts'],
                  height: '120px'
                },
                {
                  type: 'arr',
                  label: ['', '', '', '', ''],
                  height: '120px'
                },
                {
                  type: 'arr',
                  label: ['不达标不参评。', '不达标不参评。', '达到,得 1 分。', '达到,得 1 分。', '达到得 1 分。'],
                  height: '120px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '16.藏书质量（6 分）',
                  height: '360px'
                },
                {
                  type: 'arr',
                  label: ['A.馆藏书刊种类齐全、重点突出，有较高的科学及实用价值，印刷质量高。B.严把质量关，藏书必须符合《中小学图书馆（室）馆配图书适宜性评价标准》要求，严禁非法出版物流入学校图书馆。C.近3 年，每学期馆藏图书流通品种数不少于藏书总品种数的 80%。D.藏书结构要符合《中小学图书馆（室）藏书分类比例表》要求。E.加强数字化文献资源的建设，注重质量，防止数字垃圾，加强版权意识，并对多样化的信息资源进行系统整合。', '复本数量≤5。'],
                  height: '180px'
                },
                {
                  type: 'arr',
                  label: ['5', '1'],
                  height: '180px'
                },
                {
                  type: 'inputArr',
                  label: ['cszz_zl', 'cszz_fbzl'],
                  height: '180px'
                },
                {
                  type: 'arr',
                  label: ['', ''],
                  height: '180px'
                },
                {
                  type: 'arr',
                  label: ['每项 1 分。', '达到得 1 分。'],
                  height: '180px'
                }
              ]
            ]
          },
          {
            label: '图书经费（3 分）',
            child: [
              [
                {
                  type: 'str',
                  label: '17.经费落实与管理（3 分）',
                  height: '240px'
                },
                {
                  type: 'arr',
                  label: ['三年内每年生均图书经费投入≥30 元。', '图书经费专款专用，图书馆办公用品、设备添置费等不得占用图书经费。', '合理使用购书经费，有年度馆藏分析和采购计划。完善图书经费财产的管理，加强图书经费使用的监督检查。'],
                  height: '80px'
                },
                {
                  type: 'arr',
                  label: ['1', '1', '1'],
                  height: '80px'
                },
                {
                  type: 'inputArr',
                  label: ['zflsygl_snnmnsj', 'zflsygl_tsjfzkzy', 'zflsygl_hlsygsjf'],
                  height: '80px'
                },
                {
                  type: 'arr',
                  label: ['', '', ''],
                  height: '80px'
                },
                {
                  type: 'arr',
                  label: ['每项 1 分。', '经费能按要求落实的得1分', '达到得 1 分。'],
                  height: '80px'
                }
              ]
            ]
          }
        ],
        tjbzConfig: {
          gsmj_tsggs: [2, 0.5, '请填写数字且最大为2'],
          gsmj_xsyls: [2, 0.5, '请填写数字且最大为2'],
          gsmj_jsyls: [2, 0.5, '请填写数字且最大为2'],
          gsmj_dzstyls: [2, 0.5, '请填写数字且最大为2'],
          gsmj_cbs: [1, 0.5, '请填写数字且最大为1'],
          ssyq: [1, 0.5, '请填写数字且最大为1'],
          clss: [1, 0.5, '请填写数字且最大为1'],
          bgss: [1, 0.5, '请填写数字且最大为1'],
          dzylsss: [4, 0.5, '请填写数字且最大为4'],
          fhss: [1, 0.5, '请填写数字且最大为1'],
          dgzm: [2, 0.5, '请填写数字且最大为2'],
          cskl_cz: [4, 0.5, '请填写数字且最大为4'],
          cskl_jsn: [1, 0.5, '请填写数字且最大为1'],
          cskl_bkzl: [1, 0.5, '请填写数字且最大为1'],
          cskl_gjsckszl: [1, 0.5, '请填写数字且最大为1'],
          cskl_pyszts: [1, 0.5, '请填写数字且最大为1'],
          cszz_zl: [5, 0.5, '请填写数字且最大为5'],
          cszz_fbzl: [1, 0.5, '请填写数字且最大为1'],
          zflsygl_snnmnsj: [1, 0.5, '请填写数字且最大为1'],
          zflsygl_tsjfzkzy: [1, 0.5, '请填写数字且最大为1'],
          zflsygl_hlsygsjf: [1, 0.5, '请填写数字且最大为1']
        },
        glgz: [
          {
            label: '创建项目',
            child: [
              [
                {
                  type: 'str',
                  label: '创建内容',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '创建内容说明',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '分值',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '自评',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '得分',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '创建标准',
                  height: '120px'
                }
              ]
            ]
          },
          {
            label: '常规管理（5 分）',
            child: [
              [
                {
                  type: 'str',
                  label: '18.规章制度（3 分）',
                  height: '300px'
                },
                {
                  type: 'arr',
                  label: ['建立健全各项规章制度：（1）人员岗位责任制；（2）图书馆业务工作细则（含采编、典藏、流通、阅览细则）；（3）文献阅览和外借制度；（4）文献丢失和损坏的赔偿制度；（5）对文献的剔除和处理办法；（6）统计与报表制度；（7）计算机使用管理规章制度；（8）电子阅览室使用规则。', '上述各项规章制度执行情况良好。'],
                  height: '150px'
                },
                {
                  type: 'arr',
                  label: ['2', '1'],
                  height: '150px'
                },
                {
                  type: 'inputArr',
                  label: ['gzzz_jljqgxgzzd', 'gzzz_ssgxgzzdzx'],
                  height: '150px'
                },
                {
                  type: 'arr',
                  label: ['', ''],
                  height: '150px'
                },
                {
                  type: 'arr',
                  label: ['缺一项扣 0.5 分，最多扣 2分。', '缺一项扣 0.5 分，最多扣 1分。'],
                  height: '150px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '19.计划总结 （2 分）',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '每学期认真制订切实可行的工作计划和进行学期工作总结（图书宣传、读书活动、专题讲座、配合新课程实施、服务教育教学活动）。',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '2',
                  height: '80px'
                },
                {
                  type: 'input',
                  label: 'jhzj',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '工作计划 1 分，工作总结 1 分。',
                  height: '80px'
                }
              ]
            ]
          },
          {
            label: '文献管理 (14 分)',
            child: [
              [
                {
                  type: 'str',
                  label: '20.信息化管 理（4 分）',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '采用图书馆专业软件管理，工作人员熟练利用图书馆自动化管理系统，定期进行系统维护、数据备份并有相关记录或数据备份载体。',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '4',
                  height: '80px'
                },
                {
                  type: 'input',
                  label: 'xxhgl',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '不达标不参评。',
                  height: '80px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '21.文献分类 （2 分）',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '按《中国图书馆分类法》对馆藏图书、音像等资料进行分类，结合本馆实际，适当掌握级次。',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '2',
                  height: '120px'
                },
                {
                  type: 'input',
                  label: 'wxfl',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '按《中国图书馆分类法》对 文献进行分类，得 1 分；图书加工完整，排架准确有 序，得 0.5 分； 标示牌醒目，得 0.5分。',
                  height: '120px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '22.文献加工 及排架（2.5 分）',
                  height: '160px'
                },
                {
                  type: 'arr',
                  label: ['文献应及时加工并上架，馆藏文献上应图章齐全；书标粘贴整齐规范、同一库室颜色形状一致，索书号书写工整、清楚。', '书架排列科学合理、整齐美观，按《中国图书馆分类法》体系组织馆藏文献；索书号顺序不乱；书架上大小架标齐全，类号类目标识清楚、明确。'],
                  height: '80px'
                },
                {
                  type: 'arr',
                  label: ['1', '1.5'],
                  height: '80px'
                },
                {
                  type: 'inputArr',
                  label: ['wxjgjpj_wxyjsjgbsj', 'wxjgjpj_sjplkxhl'],
                  height: '80px'
                },
                {
                  type: 'arr',
                  label: ['', ''],
                  height: '80px'
                },
                {
                  type: 'arr',
                  label: ['图书验收以目志为准。', '每项 0.5 分。'],
                  height: '80px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '23.文献检索 （1 分）',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '计算机管理能够满足师生进行文献检索，能从题名、责任者、分类、主题四方面检索书目。',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '1',
                  height: '60px'
                },
                {
                  type: 'input',
                  label: 'wxjs',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '缺一项，扣 0.5 分，最多扣 1 分。',
                  height: '60px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '24.期刊管理 （1.5 分）',
                  height: '160px'
                },
                {
                  type: 'arr',
                  label: ['期刊按《中图法期刊分类表》或《中国图书馆分类法》分类，期刊保藏有序完整，定期装订成册，合订本加工符合规范。', '新刊到馆要及时盖章、登录、整理，一日内上架阅览。'],
                  height: '80px'
                },
                {
                  type: 'arr',
                  label: ['1', '0.5'],
                  height: '80px'
                },
                {
                  type: 'inputArr',
                  label: ['qkgl_qkfl', 'qkgl_xqkzl'],
                  height: '80px'
                },
                {
                  type: 'arr',
                  label: ['', ''],
                  height: '80px'
                },
                {
                  type: 'arr',
                  label: ['完整规范得 1 分。', '及时加工整理得 0.5 分。'],
                  height: '80px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '25.书刊剔除 （1.5 分）',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: 'A.定期清点馆藏文献，及时进行剔旧工作。B.及时修补还有价值的破损书刊，延长书刊使用寿。C.对丢失或剔除文献，应严格办理审批注销手续，及时处理计算机账、记录，做到账、书一致。',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '1.5',
                  height: '120px'
                },
                {
                  type: 'input',
                  label: 'sktc',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '120px'
                },
                {
                  type: 'str',
                  label: '定期清点、及时剔旧 0.5 分。修补书刊 0.5 分。达到，得 0.5分。',
                  height: '120px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '26.网络应用（1.5 分）',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '建立图书馆网站，与校园网、公共网联网，通过网页发布新书、教改信息、开展图书预约、续借业务、进行书评、网络导航等服务，实现网络化管理，资源共享。',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '1.5',
                  height: '80px'
                },
                {
                  type: 'input',
                  label: 'wlyy',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '缺一项，扣 1 分，最多扣 1.5分。',
                  height: '80px'
                }
              ]
            ]
          },
          {
            label: '成绩管理（2 分）',
            child: [
              [
                {
                  type: 'str',
                  label: '27.工作荣誉（2 分）',
                  height: '160px'
                },
                {
                  type: 'arr',
                  label: ['近 5 年来，图书馆集体获校级以上表彰。', '近 5 年来，图书馆工作人员获得校级以上先进。'],
                  height: '80px'
                },
                {
                  type: 'arr',
                  label: ['1', '1'],
                  height: '80px'
                },
                {
                  type: 'inputArr',
                  label: ['gzry_jt', 'gzry_gr'],
                  height: '80px'
                },
                {
                  type: 'arr',
                  label: ['', ''],
                  height: '80px'
                },
                {
                  type: 'arr',
                  label: ['市级以上表彰 1 分，县级或校级表彰 0.5 分。可累计，但最多得1 分。', '市级以上先进 1 分，县级或校级先进 0.5 分。可累计，但最多得1 分。'],
                  height: '80px'
                }
              ]
            ]
          }
        ],
        glgzConfig: {
          gzzz_jljqgxgzzd: [2, 0.5, '请填写数字且最大为2'],
          gzzz_ssgxgzzdzx: [1, 0.5, '请填写数字且最大为1'],
          jhzj: [2, 0.5, '请填写数字且最大为2'],
          xxhgl: [4, 0.5, '请填写数字且最大为4'],
          wxfl: [2, 0.5, '请填写数字且最大为2'],
          wxjgjpj_wxyjsjgbsj: [1, 0.5, '请填写数字且最大为1'],
          wxjgjpj_sjplkxhl: [1.5, 0.5, '请填写数字且最大为1.5'],
          wxjs: [1, 0.5, '请填写数字且最大为1'],
          qkgl_qkfl: [1, 0.5, '请填写数字且最大为1'],
          qkgl_xqkzl: [0.5, 0.5, '请填写数字且最大为0.5'],
          sktc: [1.5, 0.5, '请填写数字且最大为1.5'],
          wlyy: [1.5, 0.5, '请填写数字且最大为1.5'],
          gzry_jt: [1, 0.5, '请填写数字且最大为1'],
          gzry_gr: [1, 0.5, '请填写数字且最大为1']
        },
        dzgz: [
          {
            label: '创建项目',
            child: [
              [
                {
                  type: 'str',
                  label: '创建内容',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '创建内容说明',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '分值',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '自评',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '得分',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '创建标准',
                  height: '100px'
                }
              ]
            ]
          },
          {
            label: '基本服务(12 分)',
            child: [
              [
                {
                  type: 'str',
                  label: '28.借阅时间（4 分）',
                  height: '120px'
                },
                {
                  type: 'arr',
                  label: ['实行全周开放，每周≥40 小时;对学生有效开放时间每天≥2.5 小时。', '寒暑假期间应安排时间开馆，保证师生借阅。'],
                  height: '60px'
                },
                {
                  type: 'arr',
                  label: ['3', '1'],
                  height: '60px'
                },
                {
                  type: 'inputArr',
                  label: ['jysj_qzkf', 'jysj_hsj'],
                  height: '60px'
                },
                {
                  type: 'arr',
                  label: ['', ''],
                  height: '60px'
                },
                {
                  type: 'arr',
                  label: ['达到各得 1.5 分。', '有安排的得 1 分。'],
                  height: '60px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '29.借阅模式（3 分）',
                  height: '80px'
                },
                {
                  type: 'arr',
                  label: ['向师生实行借、阅合一的全开架借书服务。', '发证率 100%。'],
                  height: '40px'
                },
                {
                  type: 'arr',
                  label: ['2', '1'],
                  height: '40px'
                },
                {
                  type: 'inputArr',
                  label: ['jyms_jsfw', 'jyms_fzl'],
                  height: '40px'
                },
                {
                  type: 'arr',
                  label: ['', ''],
                  height: '40px'
                },
                {
                  type: 'arr',
                  label: ['不达标不参评。', '达到得 1 分。'],
                  height: '40px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '30.借阅册数（3 分）',
                  height: '40px'
                },
                {
                  type: 'str',
                  label: '每学年书刊生均借阅册数≥10 册。',
                  height: '40px'
                },
                {
                  type: 'str',
                  label: '3',
                  height: '40px'
                },
                {
                  type: 'input',
                  label: 'jycs',
                  height: '40px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '40px'
                },
                {
                  type: 'str',
                  label: '不达标不参评。',
                  height: '40px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '31.读者到馆率 统计 及分析（2 分）',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '定期(每学期至少 2次)对读者借阅倾向、需求进行分析，并及时发布图书利用率、读者到馆率、读者借阅倾向及需求分析，为学校的教育、教学提供第一手资料。',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '2',
                  height: '100px'
                },
                {
                  type: 'input',
                  label: 'dzdgltjjfx',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '分析、发布各得 1 分。',
                  height: '100px'
                }
              ]
            ]
          },
          {
            label: '服务教育教学(14分)',
            child: [
              [
                {
                  type: 'str',
                  label: '32.读书活动（2 分）',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '组织各种形式的读书活动。如开设讲座，开展书评，征文、演讲、辩论，组织读书兴趣小组活动等。',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '2',
                  height: '60px'
                },
                {
                  type: 'input',
                  label: 'dshd',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '每学期读书活动等由图书馆教师主办或协办，开展 1 项得 1分，最多得 2 分',
                  height: '60px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '33.配合课改（2 分）',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '配合学生活动或教师教研、课件制作等，在教育、教学、开发智力等方面取得成绩。',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '2',
                  height: '60px'
                },
                {
                  type: 'input',
                  label: 'phkg',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '有资料说明，得 2 分。',
                  height: '60px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '34.图情教育（1 分）',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '每学年对新生进行入馆教育、图书馆知识教育。',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '1',
                  height: '60px'
                },
                {
                  type: 'input',
                  label: 'tqjy',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '有资料说明，得 1 分。',
                  height: '60px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '35.阅读指导（3 分）',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: 'A.开设阅读指导课，培养学生读书兴趣，指导学生利用图书馆，提高学生获取知识的技能和终身学习的能力。B.近3 年，阅读指导课获市级以上奖项。',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '3',
                  height: '80px'
                },
                {
                  type: 'input',
                  label: 'ydzd',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '80px'
                },
                {
                  type: 'str',
                  label: '每项 1.5 分。',
                  height: '80px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '36.书目宣传（1 分）',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '利用各种形式宣传、推荐优秀读物。如编制新书目录和简介、推荐书目、专题导读书目及进行书刊展览等。',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '1',
                  height: '60px'
                },
                {
                  type: 'input',
                  label: 'smxc',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '达到得 1 分。',
                  height: '60px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '37.文献工作（3 分）',
                  height: '120px'
                },
                {
                  type: 'arr',
                  label: ['充分利用网络搜集国内外最新教育动态和教科研前沿信息，为学校教科研服务。', '多途径收集教育、教学、科研资料，编撰二次文献，服务教育、教学工作。'],
                  height: '60px'
                },
                {
                  type: 'arr',
                  label: ['1', '2'],
                  height: '60px'
                },
                {
                  type: 'inputArr',
                  label: ['wxgz_sjxx', 'wxgz_sjzl'],
                  height: '60px'
                },
                {
                  type: 'arr',
                  label: ['', ''],
                  height: '60px'
                },
                {
                  type: 'arr',
                  label: ['达到得 1 分。', '近 3 年内，每学期每编 40 条得 1 分，最多得 2 分'],
                  height: '60px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '38.检索咨询服务（1 分）',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '能指导读者查找所需资料、提供检索途径，为读者解答咨询，并有咨询记录，主动服务。',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '1',
                  height: '60px'
                },
                {
                  type: 'input',
                  label: 'jszxfw',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '有咨询记录，得 1 分。',
                  height: '60px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '39.信息交流（1 分）',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '能与外校进行文献信息交流。',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '1',
                  height: '60px'
                },
                {
                  type: 'input',
                  label: 'xxjl',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '60px'
                },
                {
                  type: 'str',
                  label: '有资料说明，得 1 分。',
                  height: '60px'
                }
              ]
            ]
          }
        ],
        dzgzConfig: {
          jysj_qzkf: [3, 0.5, '请填写数字且最大为3'],
          jysj_hsj: [1, 0.5, '请填写数字且最大为1'],
          jyms_jsfw: [2, 0.5, '请填写数字且最大为2'],
          jyms_fzl: [1, 0.5, '请填写数字且最大为1'],
          jycs: [3, 0.5, '请填写数字且最大为3'],
          dzdgltjjfx: [2, 0.5, '请填写数字且最大为2'],
          dshd: [2, 0.5, '请填写数字且最大为2'],
          phkg: [2, 0.5, '请填写数字且最大为2'],
          tqjy: [1, 0.5, '请填写数字且最大为1'],
          ydzd: [3, 0.5, '请填写数字且最大为3'],
          smxc: [1, 0.5, '请填写数字且最大为1'],
          wxgz_sjxx: [1, 0.5, '请填写数字且最大为1'],
          wxgz_sjzl: [2, 0.5, '请填写数字且最大为2'],
          jszxfw: [1, 0.5, '请填写数字且最大为1'],
          xxjl: [1, 0.5, '请填写数字且最大为1']
        },
        tscx: [
          {
            label: '创建项目',
            child: [
              [
                {
                  type: 'str',
                  label: '创建内容',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '创建内容说明',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '分值',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '自评',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '得分',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '创建标准',
                  height: '100px'
                }
              ]
            ]
          },
          {
            label: '特色与创新（10 分）',
            child: [
              [
                {
                  type: 'str',
                  label: '40. 特 色 服务（4 分）',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '由学校图书馆自行开创的服务内容，被上级部门肯定或被本校师生认可并在日常教学活动中已经使用的，且具有示范作用和推广价值。',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '4',
                  height: '100px'
                },
                {
                  type: 'input',
                  label: 'tefw',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '特色服务取得成效，在国家、省、市、县级会议上做过经验交流分别得4分、3 分、2 分和 1 分。',
                  height: '100px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '41. 公 共 服务（3 分）',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '通过外借、图书漂流等多种形式面向社会开放，充分发挥图书作用，实现效益最大化。图书馆在本地区具有一定影响力。',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '3',
                  height: '100px'
                },
                {
                  type: 'input',
                  label: 'ggfw',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '面向社会公众开放，得 2分；有一定社会影响力，得 1 分。',
                  height: '100px'
                }
              ],
              [
                {
                  type: 'str',
                  label: '42. 工 作 创新（3 分）',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '图书馆工作在科学、规范、有序、高效的基础上，工作有创新、有特色。',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '3',
                  height: '100px'
                },
                {
                  type: 'input',
                  label: 'gzcx',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '',
                  height: '100px'
                },
                {
                  type: 'str',
                  label: '管理与应用确有特色，能 因地制宜，受到省级以上部门或媒体表扬、报道， 得 3 分、市、县级部门或媒体表扬、报道，分别得 2 分和 1 分。',
                  height: '100px'
                }
              ]
            ]
          }
        ],
        tscxConfig: {
          tefw: [4, 0.5, '请填写数字且最大为4'],
          ggfw: [3, 0.5, '请填写数字且最大为3'],
          gzcx: [3, 0.5, '请填写数字且最大为3']
        },
        data1: [
          {
            type: 'str',
            label: '学校',
            height: '88px',
            width: '199px'
          },
          {
            type: 'value',
            label: 'school_name',
            height: '88px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '联系电话',
            height: '88px',
            width: '199px'
          },
          {
            type: 'value',
            label: 'phone',
            height: '88px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '地址',
            height: '88px',
            width: '199px'
          },
          {
            type: 'value',
            label: 'address',
            height: '88px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '邮编',
            height: '88px',
            width: '199px'
          },
          {
            type: 'value',
            label: 'postcode',
            height: '88px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '学校基本情况',
            height: '62px',
            width: '100%'
          },
          {
            type: 'str',
            label: '学校类型',
            height: '118px',
            width: '199px'
          },
          {
            type: 'checkbox',
            label: 'school_type',
            height: '118px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '办学规模',
            height: '118px',
            width: '199px'
          },
          {
            type: 'arr',
            label: [
              {
                type: 'str',
                label: '班级数:'
              },
              {
                type: 'value',
                label: 'bjs'
              },
              {
                type: 'str',
                label: '学生数:'
              },
              {
                type: 'value',
                label: 'xss'
              }
            ],
            height: '118px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '计算机管理',
            height: '118px',
            width: '199px'
          },
          {
            type: 'arr',
            label: [
              {
                type: 'str',
                label: '软件名称及版本:'
              },
              {
                type: 'value',
                label: 'rjmcjbb'
              },
              {
                type: 'str',
                label: '软件注册时间：'
              },
              {
                type: 'value',
                label: 'rjzcsj'
              }
            ],
            height: '118px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '借阅方式',
            height: '118px',
            width: '199px'
          },
          {
            type: 'checkbox',
            label: 'jrfs',
            height: '118px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '馆藏图书总数',
            height: '118px',
            width: '199px'
          },
          {
            type: 'value',
            label: 'tszs',
            height: '118px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '生均配备图书数量',
            height: '118px',
            width: '199px'
          },
          {
            type: 'value',
            label: 'sjpbtss',
            height: '118px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '人员情况',
            height: '200px',
            width: '199px'
          },
          {
            type: 'arr',
            label: [
              {
                type: 'str',
                label: '专职人员数量:'
              },
              {
                type: 'value',
                label: 'zzrysl'
              },
              {
                type: 'str',
                label: ' 馆长素质(学历/职称):'
              },
              {
                type: 'value',
                label: 'gzsz'
              },
              {
                type: 'str',
                label: '业务培训:'
              },
              {
                type: 'checkbox',
                label: 'ywpx'
              },
              {
                type: 'str',
                label: '计算机证书(名称):'
              },
              {
                type: 'value',
                label: 'jsjzs'
              }
            ],
            height: '200px',
            width: 'calc(100% - 199px)'
          },
          {
            type: 'str',
            label: '学校自评情况',
            height: '62px',
            width: '100%'
          },
          {
            type: 'str',
            label: '评估项目',
            height: '62px',
            width: '199px'
          },
          {
            type: 'str',
            label: '分值',
            height: '62px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '自评得分',
            height: '62px',
            width: '199px'
          },
          {
            type: 'str',
            label: '备注',
            height: '62px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '体制队伍',
            height: '62px',
            width: '199px'
          },
          {
            type: 'str',
            label: '17分',
            height: '62px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'value',
            label: 'tzdw',
            height: '62px',
            width: '199px'
          },
          {
            type: 'str',
            label: '',
            height: '62px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '条件保障',
            height: '62px',
            width: '199px'
          },
          {
            type: 'str',
            label: '36分',
            height: '62px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'value',
            label: 'tjbz',
            height: '62px',
            width: '199px'
          },
          {
            type: 'str',
            label: '',
            height: '62px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '管理工作',
            height: '62px',
            width: '199px'
          },
          {
            type: 'str',
            label: '21分',
            height: '62px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'value',
            label: 'glgz',
            height: '62px',
            width: '199px'
          },
          {
            type: 'value',
            label: '',
            height: '62px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '读者工作',
            height: '62px',
            width: '199px'
          },
          {
            type: 'str',
            label: '26分',
            height: '62px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'value',
            label: 'dzgz',
            height: '62px',
            width: '199px'
          },
          {
            type: 'value',
            label: '',
            height: '62px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '特色与创新',
            height: '62px',
            width: '199px'
          },
          {
            type: 'str',
            label: '10分',
            height: '62px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'value',
            label: 'tscx',
            height: '62px',
            width: '199px'
          },
          {
            type: 'str',
            label: '',
            height: '62px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '总分',
            height: '62px',
            width: '199px'
          },
          {
            type: 'str',
            label: '110分',
            height: '62px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'value',
            label: 'zf',
            height: '62px',
            width: '199px'
          },
          {
            type: 'str',
            label: '',
            height: '62px',
            width: 'calc(50% - 199px)'
          },
          {
            type: 'str',
            label: '学校意见',
            height: '188px',
            width: '199px'
          },
          {
            type: 'other',
            label: '',
            height: '188px',
            width: 'calc(100% - 199px)'
          },
          {
            type: 'str',
            label: '县（市、区）意见',
            height: '188px',
            width: '199px'
          },
          {
            type: 'other',
            label: '',
            height: '188px',
            width: 'calc(100% - 199px)'
          },
          {
            type: 'str',
            label: '省辖市、省直管县（市）意见',
            height: '188px',
            width: '199px'
          },
          {
            type: 'other',
            label: '',
            height: '188px',
            width: 'calc(100% - 199px)'
          }
        ]
      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: [],
      state: (v) => {
        return new Promise((resolve) => {
          api.library.retrieve.state(v).then((res) => {
            resolve(res.data)
          })
        })
      },
      data1: (v) => {
        return new Promise((resolve) => {
          api.library.retrieve.data(v).then((res) => {
            const info = {}
            if (res.data.length) {
              info.school_name = res.data[0].zxsb.school_name
              info.phone = res.data[0].zxsb.phone
              info.address = res.data[0].zxsb.address
              info.postcode = res.data[0].zxsb.postcode
              info.school_type = res.data[0].zxsb.school_type
              info.bjs = `${res.data[0].zxsb.bjs}班`
              info.xss = `${res.data[0].zxsb.xss}人`
              info.rjmcjbb = res.data[0].zxsb.rjmcjbb
              info.rjzcsj = res.data[0].zxsb.rjzcsj
              info.jrfs = res.data[0].zxsb.jrfs
              info.tszs = `${res.data[0].zxsb.tszs}册`
              info.sjpbtss = `${res.data[0].zxsb.sjpbtss}册`
              info.zzrysl = `${res.data[0].zxsb.zzrysl}人`
              info.gzsz = res.data[0].zxsb.gzsz
              info.ywpx = res.data[0].zxsb.ywpx
              info.jsjzs = res.data[0].zxsb.jsjzs
              info.tzdw = `${Object.values(res.data[1].tzdw).reduce((a, b) => { return a + b })}分`
              info.tjbz = `${Object.values(res.data[2].tjbz).reduce((a, b) => { return a + b })}分`
              info.glgz = `${Object.values(res.data[3].glgz).reduce((a, b) => { return a + b })}分`
              info.dzgz = `${Object.values(res.data[4].dzgz).reduce((a, b) => { return a + b })}分`
              info.tscx = `${Object.values(res.data[5].tscx).reduce((a, b) => { return a + b })}分`
              info.zf = `${Number(info.tzdw.split('分')[0]) + Number(info.tjbz.split('分')[0]) + Number(info.glgz.split('分')[0]) + Number(info.dzgz.split('分')[0]) + Number(info.tscx.split('分')[0])}分`
            }
            resolve(info)
          })
        })
      },
      data2: (v) => {
        return new Promise((resolve) => {
          api.library.retrieve.data(v).then((res) => {
            const obj = {
              zxsb: {}
            }
            const obj2 = {}
            if (res.data.length) {
              obj.zxsb.bjs = res.data[0].zxsb.bjs
              obj.zxsb.xss = res.data[0].zxsb.xss
              obj.zxsb.rjmcjbb = res.data[0].zxsb.rjmcjbb
              obj.zxsb.rjzcsj = res.data[0].zxsb.rjzcsj
              obj.zxsb.jrfs = res.data[0].zxsb.jrfs
              obj.zxsb.tszs = res.data[0].zxsb.tszs
              obj.zxsb.sjpbtss = res.data[0].zxsb.sjpbtss
              obj.zxsb.zzrysl = res.data[0].zxsb.zzrysl
              obj.zxsb.gzsz = res.data[0].zxsb.gzsz
              obj.zxsb.jsjzs = res.data[0].zxsb.jsjzs
              obj.zxsb.ywpx = res.data[0].zxsb.ywpx
              res.data[0] = obj
              obj2.zxsb = res.data[0].zxsb
              obj2.tzdw = res.data[1].tzdw
              obj2.tjbz = res.data[2].tjbz
              obj2.glgz = res.data[3].glgz
              obj2.dzgz = res.data[4].dzgz
              obj2.tscx = res.data[5].tscx
            }
            resolve(obj2)
          })
        })
      },
      data3: (v) => {
        return new Promise((resolve) => {
          api.library.retrieve.libraryMedia(v).then((res) => {
            resolve(res.data.data)
          })
        })
      },
      data4: (v) => {
        return new Promise((resolve) => {
          api.library.retrieve.data(v).then((res) => {
            resolve(res.data)
          })
        })
      },
      article: (v) => {
        return new Promise((resolve) => {
          api.school.retrieve.article(v).then((res) => {
            if (res.data.length) {
              resolve(res.data[0])
            } else {
              resolve({})
              // Message.error("暂无详情");
            }
          })
        })
      }
    }
  },
  contrast: {
    viewInfo: {
      obj: {
        basics: [
          {
            label: '发布时间：',
            model: 'created_date',
            type: 'text',
            status: 0
          }
        ]
      },
      data: {}
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: [],
      data1: (v) => {
        return new Promise((resolve) => {
          api.school.retrieve.data(v).then((res) => {
            if (res.data.data.length) {
              res.data.data.map((item) => {
                item.name = item.school_name
                item.cover_pic = item.cover_img
                  ? item.cover_img
                  : require(`@/assets/demo/library.jpg`)
              })
            }
            resolve(res.data.data)
          })
        })
      },
      article: (v) => {
        return new Promise((resolve) => {
          api.school.retrieve.article(v).then((res) => {
            if (res.data.length) {
              resolve(res.data[0])
            } else {
              Message.error('暂无详情')
            }
          })
        })
      }
    }
  }
}
export default library
